export default __webpack_public_path__ + "static/media/info_2.10601855.jpg";